import { GoogleLoginProvider, FacebookLoginProvider, SocialAuthServiceConfig, MicrosoftLoginProvider } from "@abacritt/angularx-social-login";
import { ErrorHandler, Provider } from "@angular/core"
import { RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha-2";
import { ErrorHandlerService } from "./data-services/handlers/error.handler";
import { NgcCookieConsentConfig } from "ngx-cookieconsent";
import { environment } from "../environments/environment";

export const provideSocialAuth: Provider = {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        lang: 'en',
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              'clientId'
            )
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('clientId')
          }
        ],
        onError: (err) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,
}

// export const provideSocialAuth: Provider = {
//         // Social auth login
//         provide: 'SocialAuthServiceConfig',
//         useValue: {
//             autoLogin: false,
//             lang: 'en',
//             providers: [
//                 {
//                     id: GoogleLoginProvider.PROVIDER_ID,
//                     provider: new GoogleLoginProvider(environment.google.GOOGLE_CLIENT_ID,
//                         {
//                             oneTapEnabled: false
//                         }
//                     )
//                 },
//                 {
//                     id: FacebookLoginProvider.PROVIDER_ID,
//                     provider: new FacebookLoginProvider(environment.facebook.FACEBOOK_APP_ID,
//                         {
//                             scopes: [],
//                             return_scrops: true,
//                             enable_profile_selector: true
//                         }
//                     )
//                 },
//                 {
//                     id: MicrosoftLoginProvider.PROVIDER_ID,
//                     provider: new MicrosoftLoginProvider(environment.microsoft.AD_CLIENT_ID,
//                         {
//                             redirect_uri: 'https://preview.lrptickets.co.uk'
//                         }
//                     ),
//                 },
//             ],
//             onError: (err) => console.error(err)
//         } as SocialAuthServiceConfig
//     }, 

export const provideRecaptcha: Provider = { provide: RECAPTCHA_V3_SITE_KEY, useValue: "6LcDm2kpAAAAAH4rSLWeH8nX3qB0EgVtY3t_lN4B" }

export const provideErrorHandler:Provider = { provide: ErrorHandler, useClass: ErrorHandlerService }

export const cookieConfig: NgcCookieConsentConfig = {
    cookie: {
        domain: environment.cookie.DOMAIN
    },
    position: 'bottom',
    theme: 'edgeless',
    palette: {
        popup: {
            background: '#E9E9E9',
            text: '#000000',
            link: '#000000'
        },
        button: {
            background: '#CFCFCF',
            text: '#000000',
            border: 'transparent'
        }
    },
    revokeBtn: '<div></div>',
    elements: {
        deny: '<a aria-label="decline" role"button" tabindex="0" class="cc-btn cc-deny" style="background-color: #CFCFCF;">Deny Cookies</a>',
        allow: '<a aria-label="allow cookies" role="button" tabindex="0" class="cc-btn cc-allow">Allow all cookies</a>'
    },
    type: 'opt-out',
    content: {
        message: 'We would like to use some cookies to track usage of this website, to better aid us in developing and troubleshooting. Your data may be shared with third parties for analysis',
        dismiss: 'I Agree',
        deny: 'Decline',
        link: 'Cookie Policy',
        href: '/cookies',
        policy: 'Cookie Policy'
    },
    blacklistPage: [],
    autoOpen: true
}